import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserRoutingModule } from './user-routing.module';
import { UserComponent } from './user/user.component';
import { ProductsDocsComponent } from './products-docs/products-docs.component';
import { DropdownModule } from 'primeng/dropdown';
import { UserserviceService } from 'src/hp-app/services/userservice.service';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CheckOutComponent } from './check-out/check-out.component';
import { DialogModule } from 'primeng/dialog';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import {InputTextareaModule} from 'primeng/inputtextarea';
import { OrderSummaryComponent } from './order-summary/order-summary.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { CheckboxModule } from 'primeng/checkbox';
import {KeyFilterModule} from 'primeng/keyfilter';
import { CalendarModule } from 'primeng/calendar';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}


@NgModule({
  imports: [
    CommonModule,
    UserRoutingModule,
    DropdownModule,
    HttpClientModule,
    DialogModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    InputTextareaModule,
    FormsModule,
    CheckboxModule,
    KeyFilterModule,
    CalendarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })

  ],
  providers: [UserserviceService],
  declarations: [UserComponent, ProductsDocsComponent, CheckOutComponent, OrderSummaryComponent]
})
export class UserModule { }
